import { render, staticRenderFns } from "./molecularTypingAdd.vue?vue&type=template&id=12421d24&scoped=true"
import script from "./molecularTypingAdd.vue?vue&type=script&lang=js"
export * from "./molecularTypingAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12421d24",
  null
  
)

export default component.exports